import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
export function ResultsSection() {
  const results = [{
    stat: '2 Semanas',
    description: 'Agenda llena con anticipación, eliminando la incertidumbre diaria.'
  }, {
    stat: '80%',
    description: 'Reducción de No-Shows con nuestro sistema de depósito automático.'
  }, {
    stat: '40%',
    description: 'Más frecuencia de retorno de clientes actuales gracias a la retención automatizada.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-carbon" data-id="element-39">
      <div className="max-w-5xl mx-auto" data-id="element-40">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeUpVariants} className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl md:text-4xl font-bold text-gold max-w-2xl mx-auto" data-id="element-42">
            Lo que pasa cuando el Sistema A.C.E.™ trabaja para tu Salón.
          </h2>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-43">
          {results.map((result, index) => <motion.div key={index} variants={fadeUpVariants} className="text-center p-6" data-id="element-44">
              <div className="text-5xl md:text-6xl font-black text-gold mb-4" data-id="element-45">
                {result.stat}
              </div>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-46">
                {result.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}